import { mapState } from "vuex";
import get from "lodash/get";
export default {
  data() {
    return {
      already_watched_all_lessons: false,
    };
  },
  computed: {
    ...mapState("courses", ["completed_courses"]),
  },
  methods: {
    isPassedInExam(course_id) {
      const progress = this.completed_courses.find(
        (p) => get(p, "course.id", false) == course_id
      );
      return progress && Number(progress?.grade) > 7;
    },
    dispatchStartedCourses() {
      this.$store.dispatch(
        "courses/getStartedCourses",
        this.$store.state.user.user.id
      );
    },
    dispatchCompletedCourses() {
      this.$store
        .dispatch("courses/getCompletedCourses", this.$store.state.user.user.id)
        .then((data) => {
          this.$store.commit("courses/setCompletedCourses", data);
        });
    },
    dispatchCourseProgress(course_id) {
      this.$store
        .dispatch("courses/getCourseProgress", {
          course_id,
          user_id: this.$store.state.user.user.id,
        })
        .then((data) => {
          if (!data || !data.results.length) {
            this.already_watched_all_lessons = false;
          } else {
            this.already_watched_all_lessons = data.results[0].progress == 100;
          }
        })
        .finally(() => {
          this.loadingExam = false;
        });
    },
  },
};
